webpackJsonp([129],{

/***/ 1074:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            hasError: true
        };
    }
});

/***/ }),

/***/ 1075:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-checkbox', {
    model: {
      value: (_vm.hasError),
      callback: function($$v) {
        _vm.hasError = $$v
      },
      expression: "hasError"
    }
  }, [_vm._v("Show errors")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Username",
      "type": {
        'is-danger': _vm.hasError
      },
      "message": {
        'Username is not available': _vm.hasError
      }
    }
  }, [_c('b-input', {
    attrs: {
      "value": "johnsilver",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password",
      "type": {
        'is-danger': _vm.hasError
      },
      "message": [{
          'Password is too short': _vm.hasError
        },
        {
          'Password must have at least 8 characters': _vm.hasError
        }
      ]
    }
  }, [_c('b-input', {
    attrs: {
      "value": "123",
      "type": "password",
      "maxlength": "30"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1074),
  /* template */
  __webpack_require__(1075),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/129.898a89716202004d019e.js